<template>
    <div class="test-navigation">
      <h1>Navigation Test Page</h1>
      <div class="button-list">
        <!-- Buttons for navigation -->
        <button
          v-for="(page, index) in pages"
          :key="index"
          class="download-button"
          @click="navigateTo(page.path)"
        >
          Navigate to {{ page.name }}
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "TestNavigationPage",
    data() {
      return {
        // Define your routes here
        pages: [
          { name: "navigation", path: "/" },
          { name: "Page 1", path: "/page-one" },
          { name: "Page 2", path: "/page-two" },
          { name: "Page 3", path: "/page-three" },
          { name: "Page 4", path: "/page-four" },
          { name: "Page 5", path: "/page-five" },
          { name: "Page 6", path: "/page-six" },
          { name: "Page 7", path: "/page-seven" },
          { name: "Page 8", path: "/page-eight" },
          { name: "Page 9", path: "/page-nine" },
        ],
      };
    },
    methods: {
      // Method to navigate to a route
      navigateTo(path) {
        this.$router.push(path);
      },
    },
  };
  </script>
  
  <style scoped>
  .test-navigation {
    font-family: Arial, sans-serif;
    text-align: center;
    padding: 20px;
  }
  
  .button-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 300px;
    margin: 0 auto;
  }
  </style>
  